import { produce } from 'immer';

import { PROPERTY_AND_LOAN_ACTION_TYPE } from '../actions';

const initialState = {
  invalidTabs: [],
  loanAppraisalSurcharges: [],
};

const propertyAndLoanReducer = (state = initialState, { type, payload }) =>
  produce(state, draft => {
    switch (type) {
      case PROPERTY_AND_LOAN_ACTION_TYPE.GET_SUMMARY:
        draft.summary = payload;
        break;

      case PROPERTY_AND_LOAN_ACTION_TYPE.GET_PROPERTY_AND_LOAN_EDIT_DATA:
        draft.propertyAndLoanEditData = payload;
        break;

      case PROPERTY_AND_LOAN_ACTION_TYPE.GET_LOAN_AND_LOCK_EDIT_DATA:
        draft.loanAndLockEditData = payload;
        break;

      case PROPERTY_AND_LOAN_ACTION_TYPE.GET_LOAN_APPRAISAL_SURCHARGES:
        draft.loanAppraisalSurcharges = payload || [];
        break;

      case PROPERTY_AND_LOAN_ACTION_TYPE.SET_INVALID_TABS:
        draft.invalidTabs = payload;
        break;

      default:
        return state;
    }
  });

export default propertyAndLoanReducer;
